import { Ability, AuthProps, useAuth } from 'hooks/useAuth';

export const useAbility = (ability: Ability): boolean => {
  const { user } = useAuth();

  if (!user || !ability || !user.abilities) {
    return false;
  }

  return user.abilities.includes(ability);
};

export const hasAbility = (
  user: AuthProps | null,
  ability: Ability
): boolean => {
  if (!user || !ability || !user.abilities) {
    return false;
  }

  return user.abilities.includes(ability);
};
